import {observable, action, makeObservable} from "mobx";

class UsersStore {
    users = undefined;
    usersByLoginId = {};

    constructor() {
        makeObservable(this, {
            users: observable,
            usersByLoginId: observable,

            setUsers: action,
            setUser: action,
        })
    }

    initialize() {
        this.users = undefined;
        this.usersByLoginId = {};
    }

    setUsers(users) {
        this.users = users;
    }

    setUser(user) {
        if (!user || !user.user_login_id) return;
        this.usersByLoginId[user.user_login_id] = user;
    }
};

/* makeObservable(SitesStore, {
    sites: observable,
    site_hour_reports: observable,
    site_invoice_reports: observable,
    site_subscriptions: observable,

    setSites: action,
    setSiteHourReport: action,
    setSiteInvoiceReport: action,
    setSiteSubscriptionReport: action,
}); */

export default new UsersStore();
